import { Permission } from '../FeatureManagement/permission.enum';
import { TenantGroupPermissionDto } from './tenant-group-permission.dto';

export class TenantGroupPermission {
    public tenantGroupName: string;
    public groupName: string;
    public groupId: string;
    public hasPermission: boolean;

    constructor(tenantGroupDto: TenantGroupPermissionDto) {
        this.groupId = tenantGroupDto.GroupId;
        this.groupName = tenantGroupDto.GroupName;
        this.tenantGroupName = tenantGroupDto.TenantGroupName;
        this.hasPermission = tenantGroupDto.Permission === Permission.Allow;
    }
}